import { BehaviorSubject, Observable } from 'rxjs';
import {DoorCorners, Orientation, ScenarioImage} from '../../models/scenario-image';
import {Size} from '../../models/utils';
import {DeviceType} from "../../../generated/graphql";

export abstract class ScenarioImageService {
  isLoading$ = new BehaviorSubject<boolean>(false);

  abstract stopPollingForVisualisationImprovements(): void;

  /**
   * loads scenario images from backend.
   * this includes user scenarios and example images
   */
  abstract getScenarios$(): Observable<ScenarioImage[]>;

  abstract getScenariosObservable(): Observable<Array<ScenarioImage>>

  abstract getSelected$(): Observable<ScenarioImage>;

  abstract getSelected(): ScenarioImage | undefined;

  abstract selectScenario(image: ScenarioImage): void;

  abstract updateCorners(corners: Array<DoorCorners>): Promise<void>;

  abstract addDoorToCurrentScenario(args: { imageSize: Size}): Promise<{ doorCorners: DoorCorners, index: number }>

  abstract uploadUserScenario(args: { file: File, deviceType: DeviceType }): Promise<{ showRefineLayout: boolean }>;

  abstract selectScenarioByShortId(shortId: string, type: string): Promise<boolean>

  abstract deleteScenario(id: string): void;

  abstract reloadScenarios(orientation: Orientation, currentDoorTypeId: string): void

  abstract setOrientationFilter(orientation: Orientation): void;

  abstract getCurrentOrientationValue(): Promise<Orientation | undefined>

  abstract setExampleImageSetNumber(setNumber: number): void;

  abstract getNewDefaultCornersForCurrentScenario(args: {
    doorTypeId: string,
    imageSize: { width: number, height: number },
  }): Promise<DoorCorners>;
}
